<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <div slot="right" class="common-btn btn"  @click="onDelete" v-if="!isAddMode">删除</div>
            </mt-header>
        </div>
        <div class="main-content">
            <div v-if="!isAddMode">
                <flex-line :show-border="true"><span class="line-name">门店账号</span><span slot="right">{{chain.chain_name}}</span></flex-line>
            </div>
            <flex-line v-else :show-border="true" class="field-line"><span class="field-name">门店账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="chain.chain_name" /></div></flex-line>
            <flex-line class="field-line" :show-border="true"><span class="field-name">门店密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="chain.chain_passwd" /></div></flex-line>
            <flex-line class="field-line" :show-border="true"><span class="field-name">门店名称</span><div class="field-line-right" slot="right"><input class="field-input" v-model="chain.chain_addressname" /></div></flex-line>
            <flex-line class="field-line" :show-border="true"><span class="field-name">联系人姓名</span><div class="field-line-right" slot="right"><input class="field-input" type="phone" v-model="chain.chain_truename" /></div></flex-line>
            <flex-line class="field-line" :show-border="true"><span class="field-name">联系人手机</span><div class="field-line-right" slot="right"><input class="field-input" type="phone" v-model="chain.chain_mobile" /></div></flex-line>
            <flex-line class="field-line" :show-border="true"><span class="field-name">座机</span><div class="field-line-right" slot="right"><input class="field-input" type="email" v-model="chain.chain_telephony" /></div></flex-line>
            <div @click="onRegion">
            <flex-line :is-link="true" :show-border="true"><span class="line-name">地区</span><span slot="right">{{chain.chain_area_info}}</span></flex-line>
            </div>
            <flex-line class="input-wrap" :show-border="true">
            <span>地址</span>
            <div slot="right"><input class="text" type="text" v-model="chain.chain_address"><i class="iconfont" @click="popMap=true;getPosition()">&#xe6d3;</i></div>
            </flex-line>
            <flex-line :show-border="true"><span class="line-name">门店状态</span><div slot="right"><mt-switch v-model="chain.chain_state"></mt-switch></div></flex-line>
            <flex-line :show-border="true"><span class="line-name">开启自提</span><div slot="right"><mt-switch v-model="chain.chain_if_pickup"></mt-switch></div></flex-line>
            <flex-line :show-border="true"><span class="line-name">开启代收</span><div slot="right"><mt-switch v-model="chain.chain_if_collect"></mt-switch></div></flex-line>
            <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">提交</div></div>
        </div>
        <region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>
        <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="定位" class="common-header">
                    <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <map-select ref="map_select" :longitude="chain.chain_longitude" :latitude="chain.chain_latitude" @setPosition="setPosition"></map-select>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { getPointByAddress } from '../../../util/bmap'
import { getChainInfo, delChain, addChain, editChain } from '../../../api/sellerChain'
import RegionPicker from '../../../components/RegionPicker'
import MapSelect from '../../../components/MapSelect'
import flexLine from '../../flexLine'
export default {
  name: 'ChainForm',
  components:{
    flexLine,
    RegionPicker,
    MapSelect
  },
  data () {
    return {
      popMap: false,
      chain_id: 0,
      chain: {
        chain_state: true,
        chain_if_pickup: true,
        chain_if_collect: true
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.chain_id = this.$route.query.chain_id
      getChainInfo({ chain_id: this.chain_id }).then(res => {
        let chain = res.result.chain_info
        chain.chain_passwd = ''
        chain.chain_state = !!chain.chain_state
        chain.chain_if_pickup = !!chain.chain_if_pickup
        chain.chain_if_collect = !!chain.chain_if_collect
        this.chain = chain
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      // add: 添加门店，edit: 编辑门店
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增门店'
      } else {
        return '修改门店'
      }
    }
  },
  methods: {
    getPosition () {
      getPointByAddress(this.chain.chain_area_info + this.chain.chain_address).then(res => {
        if (res.result.location) {
          this.chain.chain_longitude = res.result.location.lng
          this.chain.chain_latitude = res.result.location.lat
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.chain.chain_address = name
      this.chain.chain_longitude = lng
      this.chain.chain_latitude = lat
    },
    onRegion (picker, values) {
      this.$refs.picker.currentValue = true
    },
    onPickerConfirm (values) {
      this.chain.chain_area_info = this.getRegionStr(values)

      this.chain.chain_area_3 = values[2].area_id
      this.chain.chain_area_2 = values[1].area_id
      this.$forceUpdate()
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    onDelete () {
      MessageBox.confirm('确定要删除该门店吗？').then(action => {
        delChain({chain_id:this.chain_id}).then(
          (response) => {
            this.$router.push({ name: 'SellerChainList' })
          }, (error) => {
            Toast(error.message)
          })
      })
    },
    submit () {
      if (this.isAddMode) {
        Indicator.open()
        addChain(this.chain).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            this.$router.push({ name: 'SellerChainList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editChain(this.chain).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    }
  }

}
</script>

<style scoped lang="scss">
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
.main-content{background: #fff;padding:0 $pageSpace}
    .text{text-align: right;border: 0}
</style>
